import { ProjectType } from '@lopo-tech/lopo-api'
import React from 'react'
import { RouteComponentProps } from 'react-router'
import { ProjectsOverviewPage } from 'src/pages/projects_overview'

const InfrastructureProjectsOverviewPage: React.FC<RouteComponentProps> = (props) => (
  <ProjectsOverviewPage {...props} projectType={ProjectType.InfrastructureProject} />
)

export default InfrastructureProjectsOverviewPage
